'use es6';

import GoodImageTypes from './GoodImageTypes';
export default Object.freeze([GoodImageTypes.MODULE_IMAGE_1, GoodImageTypes.MODULE_IMAGE_2, GoodImageTypes.MODULE_IMAGE_3, GoodImageTypes.MODULE_IMAGE_4, GoodImageTypes.MODULE_IMAGE_5]);